import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * テキストwithアイコンカラム
 *【内容:content:string】
 *【選択候補:candidates:{label:string,value:string}[]】
 *【アイコン:icon:string】
 *【代替アイコン:alternateIcon:string】
 *【サイズ:size:number】
 *【色:color:string】
 *【非活性:disabled:boolean】
 *【表示条件:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-text-with-icon-column',
  templateUrl: './text-with-icon-column.html',
  styles: [`
    
  `]
})
export class TextWithIconColumn extends BaseWidget {
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * 内容の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 内容に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 内容
   */
  @Input() content:string

  /**
   * 選択候補
   */
  @Input() candidates:{label:string,value:string}[]

  /**
   * アイコン
   */
  @Input() icon:string

  /**
   * 代替アイコン
   */
  @Input() alternateIcon:string

  /**
   * サイズ
   */
  @Input() size:number

  /**
   * 色
   */
  @Input() color:string

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/text-with-icon-column/text-with-icon-column.component.ts